import * as yup from 'yup'

export const createBrandDetailsValidation = yup.object({
  websiteUrl: yup.string().url().notRequired().default(''),
  industry: yup.string().notRequired().default(''),
  tone: yup.string().notRequired().default('')
})

